import { useEffect, useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';
import { CollegeWiseRegisterReportValidate, ReportShowClick } from '../../../config/Validate';
import { defaultPageRowOptions, defaultRowOptions, degreeList, SkeletonbodyTemplate, Skeletonitems } from '../../../appconfig/Settings';
import { getAllDetailsDirect, postAllData } from '../../../service/ProductService';
import { COLLEGEWISEREG, DEGREEDETAILSREPORT, DOWNLOADCOLLEGEWISEREGISTRATION, DOWNLOADDEGREEDETAILS, REPORTCOLLEGE } from '../../../config/ApiConstant';
import { CollegeWiseRegListColumns, DegreeDetailsListColumns } from '../../../appconfig/DatatableSetting';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import moment from 'moment';
import { downloadData, exportData } from '../../../appconfig/AppHelper';
import { dateTemplate } from '../../../appconfig/DatatableTemplateSetting';
import AppBreadcrumb from '../../../components/CustomeBreadcrumb/AppBreadcrumb';

export const CollegeWiseRegisterReport = () => {
    document.title = 'College Wise Register Report | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    //collge List
    const [collegesOptions, setCollegesOptions] = useState<any>([]);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [errors, setErrors] = useState<any>({});
    const [selectedDegree, setSelectedDegree] = useState<any>(null);
    const [selectedCollege, setSelectedCollege] = useState<any>(null);
    const [collegeWiseregList, setCollegeWiseregList] = useState<any>([]);
    const [showLoading, setShowLoading] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [exportLoader, setExportLoader] = useState<boolean>(false);

    // Date Object
    let today = new Date();
    const [dates, setDates] = useState<string | Date | Date[] | any | null>([new Date(today.setDate(today.getDate() - 31)), new Date()]);

    // On Date Change
    const onDateChange = (e: any) => {
        setDates(e.value);
    };

    useEffect(() => {
        getAllColleges();
    }, []);

    // Get Colleges
    const getAllColleges = async () => {
        try {
            const response = await getAllDetailsDirect(REPORTCOLLEGE + '?type=all');

            if (response) {
                const DataList: any = response?.data;
                if (DataList.length === 0) {
                    setCollegesOptions([]);
                } else {
                    let collegeData = [];
                    for (let i = 0; i < DataList.length; i++) {
                        const collegeObj: any = {};
                        collegeObj['name'] = DataList[i].orgnameeng;
                        collegeObj['code'] = DataList[i].orgcode;
                        collegeData.push(collegeObj);
                    }
                    setCollegesOptions(collegeData);
                }
            } else {
                setCollegesOptions([]);
            }
        } catch (error: any) {
            setCollegesOptions([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <div>
                    <Dropdown
                        value={selectedCollege}
                        name="college"
                        options={collegesOptions}
                        filter
                        optionLabel="name"
                        placeholder="Select College"
                        onChange={(e) => setSelectedCollege(e.value)}
                        className={errors['college'] ? 'p-invalid' : 'mr-2'}
                    />
                    <small className="p-invalid-txt">{errors['college']}</small>
                </div>
                <div>
                    <Dropdown value={selectedDegree} name="degree" options={degreeList} filter optionLabel="name" placeholder="Select Degree" onChange={(e) => setSelectedDegree(e.value)} className={errors['degree'] && 'p-invalid'} />
                    <small className="p-invalid-txt">{errors['degree']}</small>
                </div>
                <Button label="Show" onClick={() => getCollegeWiseRegisterReport()} loading={showLoading} className="ml-2"></Button>
            </>
        );
    };

    // Right toolbar
    const rightToolbarTemplate = () => {
        return (
            <>
                <Button icon="pi pi-file-export" label="Export" onClick={() => exportCSV()} className="p-button-success" loading={exportLoader}></Button>
                <Button icon="pi pi-download" label="Download" onClick={() => downloadAllData()} className="mx-2" loading={loading}></Button>
                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAllFilter()} className="p-button-outlined "></Button>
            </>
        );
    };

    //downloadDAta
    const downloadAllData = async () => {
        try {
            setLoading(true);

            // Request Data
            const requestData = {
                DegSrNo: Number(selectedDegree?.code),
                ColSrNo: Number(selectedCollege?.code)
            };

            const response = await downloadData(DOWNLOADCOLLEGEWISEREGISTRATION, 'CollegeWise_Register_Report', requestData);
            if (response === true) {
                setLoading(false);
            } else if (response === false) {
                setLoading(false);
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setLoading(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    //export CSv
    const exportCSV = async () => {
        setExportLoader(true);

        let res = await exportData('CollegeWise_Register_Report');
        if (res === true) {
            setExportLoader(false);
        } else {
            setExportLoader(false);
        }
    };

    //Clear All Filter
    const clearAllFilter = () => {
        setGlobalFieldFilter(null);
        setGlobalFilter(null);
    };

    // getCollegeWiseRegisterReportList
    const getCollegeWiseRegisterReport = async () => {
        try {
            // const { errors, isError } = CollegeWiseRegisterReportValidate(selectedCollege, selectedDegree);
            // setErrors(errors);
            // if (!isError) {
            setPageLoad(false);
            setShowLoading(true);

            // Request Data
            const requestData = {
                DegSrNo: Number(selectedDegree?.code),
                ColSrNo: Number(selectedCollege?.code)
            };

            const response = await postAllData(COLLEGEWISEREG, requestData);

            if (response) {
                setPageLoad(true);
                setShowLoading(false);
                setCollegeWiseregList(response?.data);
            }
            // }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setPageLoad(true);
                setShowLoading(false);

                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    return (
        <>
            <AppBreadcrumb currentMenu={'Reports'} pageName={'College Wise Register Report'} pageTitle={'College Wise Register Report'} goToPage={true} />

            <Toast ref={toast} />
            <div className="grid crud-demo mt-2">
                <div className="col-12">
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={collegeWiseregList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    className="datatable-responsive p-datatable-sm"
                                    emptyMessage="No Data Found"
                                    removableSort
                                >
                                    {CollegeWiseRegListColumns.map((col: any, i: any) => {
                                        if (col.field === 'EntDt' || col.field === 'OrgIDt' || col.field === 'BOD' || col.field === 'SSCYr' || col.field === 'HSCYr' || col.field === 'JoingYth' || col.field === 'Passedyth') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={dateTemplate} style={{ minWidth: '8rem' }} />;
                                        } else if (col.field === 'sr_no') {
                                            return <Column key={col.field} header={col.header} body={(_, { rowIndex }) => rowIndex + 1} style={{ minWidth: '4rem' }} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {CollegeWiseRegListColumns.map((col: any, i: any) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};
